<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';

const { t } = useI18n();
const getters = useStoreGetters();

const model = defineModel({ type: Object, required: true });

const inboxes = computed(() => {
  const allInboxes = getters['inboxes/getInboxes'].value || [];
  return allInboxes.filter(
    inbox =>
      inbox.channel_type === 'Channel::Whatsapp' ||
      inbox.channel_type === 'Channel::Api'
  );
});

const selectInbox = inbox => {
  model.value = {
    ...model.value,
    inbox,
    inboxType: inbox.channel_type === 'Channel::Whatsapp' ? 'whatsapp' : 'api',
    template: null,
    templateParams: {},
    message: '',
  };
};

const isSelected = inbox => model.value.inbox?.id === inbox.id;

const inboxTypeLabel = inbox => {
  return inbox.channel_type === 'Channel::Whatsapp' ? 'WhatsApp' : 'API';
};
</script>

<template>
  <div class="max-w-2xl">
    <h2 class="text-base font-medium text-n-slate-12">
      {{ t('CAMPAIGN.V2.WIZARD.INBOX.TITLE') }}
    </h2>
    <p class="mt-1 text-sm text-n-slate-11">
      {{ t('CAMPAIGN.V2.WIZARD.INBOX.DESCRIPTION') }}
    </p>

    <div class="grid gap-3 mt-6">
      <button
        v-for="inbox in inboxes"
        :key="inbox.id"
        class="flex items-center gap-4 p-4 text-left border rounded-lg transition-colors"
        :class="
          isSelected(inbox)
            ? 'border-n-brand bg-n-brand/5'
            : 'border-n-weak hover:border-n-slate-8'
        "
        @click="selectInbox(inbox)"
      >
        <div
          class="flex items-center justify-center w-10 h-10 rounded-lg bg-n-alpha-2"
        >
          <span class="text-sm font-medium text-n-slate-11">
            {{ inboxTypeLabel(inbox).charAt(0) }}
          </span>
        </div>
        <div class="flex-1">
          <div class="font-medium text-n-slate-12">{{ inbox.name }}</div>
          <div class="text-xs text-n-slate-11">{{ inboxTypeLabel(inbox) }}</div>
        </div>
        <div
          v-if="isSelected(inbox)"
          class="w-5 h-5 rounded-full bg-n-brand flex items-center justify-center"
        >
          <span class="text-white text-xs">&#10003;</span>
        </div>
      </button>
    </div>

    <p
      v-if="inboxes.length === 0"
      class="mt-6 text-sm text-n-slate-11"
    >
      {{ t('CAMPAIGN.V2.WIZARD.INBOX.ERROR') }}
    </p>
  </div>
</template>
